const rolesStore = {
  state: {
    rolesForUser: [],
    selectedUserToDisplayRoles: null,
  },
  reducers: {
    SET_ROLES_FOR_USER: (state, allRoles) => ({
      ...state,
      rolesForUser: allRoles,
    }),
    SET_SELECTED_USER_FOR_ROLES: (state, user) => ({
      ...state,
      selectedUserToDisplayRoles: user,
    }),
  },
};

export default rolesStore;
